module.exports = __webpack_public_path__ + "img/icon-pedido-libros.46b314e9.svg";